"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAchievementType = void 0;
var IAchievementType;
(function (IAchievementType) {
    IAchievementType["Event"] = "event";
    IAchievementType["Challenge"] = "challenge";
    IAchievementType["Milestone"] = "milestone";
})(IAchievementType || (exports.IAchievementType = IAchievementType = {}));
//# sourceMappingURL=achievement-type.js.map